import { MONEY_SCALE, ZERO_MONEY, add, allocate, compare, isNegative, lineTotal as grossLineTotal, subtract, sum, } from '@aeris/money';
export const computePurchaseTotals = (lines, headerDiscount = ZERO_MONEY, freight = ZERO_MONEY) => {
    if (lines.length === 0) {
        return isNegative(headerDiscount) || compare(headerDiscount, ZERO_MONEY) > 0
            ? { ok: false, failure: { reason: 'discount-without-lines' } }
            : {
                ok: true,
                totals: {
                    subtotal: ZERO_MONEY,
                    discount: ZERO_MONEY,
                    freight,
                    total: freight,
                    lines: [],
                },
            };
    }
    const gross = [];
    const afterLineDiscount = [];
    for (const [index, line] of lines.entries()) {
        if (isNegative(line.quantity) ||
            isNegative(line.unitCost) ||
            isNegative(line.discountAmount)) {
            return { ok: false, failure: { reason: 'negative-amount', index } };
        }
        const amount = grossLineTotal(line.quantity, line.unitCost);
        const net = subtract(amount, line.discountAmount);
        if (isNegative(net)) {
            return {
                ok: false,
                failure: { reason: 'line-discount-exceeds-line', index },
            };
        }
        gross.push(amount);
        afterLineDiscount.push(net);
    }
    const subtotal = sum(gross, MONEY_SCALE);
    const netTotal = sum(afterLineDiscount, MONEY_SCALE);
    if (compare(headerDiscount, netTotal) > 0) {
        return { ok: false, failure: { reason: 'discount-exceeds-total' } };
    }
    /*
     * `allocate` hands out the remainder one centavo at a time, weighted by each
     * line's share, so the parts sum to the whole exactly. Subtracting the
     * discount from the total instead would leave a document whose lines do not
     * add up to it — which is the shape of an NF-e the tax authority rejects.
     */
    const allocated = allocate(headerDiscount, afterLineDiscount);
    const resultLines = afterLineDiscount.map((net, index) => {
        const share = allocated[index] ?? ZERO_MONEY;
        return {
            gross: gross[index] ?? ZERO_MONEY,
            allocatedDiscount: share,
            lineTotal: subtract(net, share),
        };
    });
    const total = add(sum(resultLines.map((line) => line.lineTotal), MONEY_SCALE), freight);
    return {
        ok: true,
        totals: {
            subtotal,
            discount: headerDiscount,
            freight,
            total,
            lines: resultLines,
        },
    };
};
//# sourceMappingURL=totals.js.map